import { inRange } from 'lodash-es';
export function nowInRange(time) {
    return !time || time.length === 0 || inRange(Date.now(), time[0], time[1]);
}
